<script>
import {TokenMixin} from '@/assets/js/mixins/token-mixin';
import _ from "lodash";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: 'DeleteServer',
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  emits: ['destroy', 'delete'],
  data() {
    return {
      deleteIps: 0,
    }
  },
  props: {
    selectedItemsList: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
  },
  computed: {
    title() {
      if (this.selectedItemsList.length === 1) {
        return `Confirm delete Server: ${this.getCurrentItemForDelete().Name}`;
      } else {
        return `Confirm delete ${this.selectedItemsList.length} servers`;
      }
    },
  },
  methods: {
    getCurrentItemForDelete() {
      return _.find(this.items, {Id: this.selectedItemsList[0]})
    },
    deleteAction() {
      this.$emit('delete', this.deleteIps)
      this.$modal.hide('DeleteServer')
    },
  }
}
</script>

<template>
  <modal
      name="DeleteServer"
      height="auto"
      width="550px"
  >
    <div class="window-header">
      {{ title }}
      <a href="javascript:void(0)" class="close-modal pull-right" @click="$modal.hide('DeleteServer')"><i
          class="fa fa-times"></i></a>
    </div>
    <div class="modal-body">
      <b-form-checkbox
          v-model="deleteIps"
          value="1"
          unchecked-value=""
      >
        Do you want to delete assigned IPs?
      </b-form-checkbox>
      <br /><b class="red">DON`T FORGET TO CANSEL SERVICES IN DATACENTER</b>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" v-on:click="deleteAction()" type="button">
        <span>Yes, Delete</span>
      </button>
      <button class="btn" v-on:click="$modal.hide('DeleteServer')" type="button">
        <span>Cancel</span>
      </button>
    </div>
  </modal>
</template>

<style scoped>

</style>